import { CircleCheck, TriangleAlert, CircleSlash, Clock, Ban } from "lucide-react";

const MAP = {
  fresh: { label: "Fresh", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CircleCheck },
  approaching_stale: { label: "Approaching stale", cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Clock },
  stale: { label: "Update overdue — verify by phone", cls: "bg-amber-100 text-amber-800 border-amber-300", Icon: TriangleAlert },
  no_report: { label: "No report yet", cls: "bg-slate-100 text-slate-600 border-slate-300", Icon: CircleSlash },
};

export function FreshnessBadge({ status, testid }) {
  const cfg = MAP[status] || MAP.no_report;
  const { Icon } = cfg;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-semibold ${cfg.cls}`}
    >
      <Icon size={14} strokeWidth={2.4} />
      {cfg.label}
    </span>
  );
}

export function AvailabilityBadge({ beds, freshness, notAccepting, testid }) {
  let cls, Icon, label;
  if (notAccepting) {
    cls = "bg-rose-50 text-rose-700 border-rose-200"; Icon = Ban; label = "Not accepting";
  } else if (freshness === "stale" || freshness === "no_report") {
    cls = "bg-amber-50 text-amber-700 border-amber-200"; Icon = TriangleAlert; label = "Verify by phone";
  } else if (beds > 0) {
    cls = "bg-emerald-50 text-emerald-700 border-emerald-200"; Icon = CircleCheck; label = "Available now";
  } else {
    cls = "bg-slate-100 text-slate-600 border-slate-300"; Icon = CircleSlash; label = "No immediate availability";
  }
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-semibold ${cls}`}>
      <Icon size={14} strokeWidth={2.4} />
      {label}
    </span>
  );
}
